/* eslint-disable ember/no-controller-access-in-routes, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import { next } from '@ember/runloop';

export default class LedgerAnalysisRoute extends Route {
  queryParams = {
    from: {
      refreshModel: true,
    },
    to: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    return this.store.query('finance/line-item', {
      dateFrom: params.from,
      dateTo: params.to,
      include: 'ledgers,ledgerItems,transactions',
    });
  }

  activate() {
    super.activate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', true);
    });
  }

  deactivate() {
    super.deactivate(...arguments);
    next(this, function () {
      this.controllerFor('application').set('isWideList', false);
    });
  }
}
